module.exports = __webpack_public_path__ + "img/hd_logo.0b97a395.png";